module.exports = require('./$.global').document && document.documentElement;


//////////////////
// WEBPACK FOOTER
// D:/midea_porject/php/htdocs/~/core-js/library/modules/$.html.js
// module id = 55
// module chunks = 0